// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ProjectsBoard_wrap__2Mrgr","task":"ProjectsBoard_task__3_jy1"};